export default "__VITE_ASSET__c7bfd83d__"